module.exports = __webpack_public_path__ + "static/img/excel.bffd4b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/excel.png
// module id = aozq
// module chunks = 1